import { Directive } from "@angular/core";

@Directive({
    selector: '[tab-item-content]',
})
export class TabItemContentDirective { }
